'use client';

import { useEffect, useState } from 'react';

import { createPortal } from 'react-dom';

import { useSearchParams } from 'next/navigation';

import ReactConfetti from 'react-confetti';

export function Confetti() {
  const [mounted, setMounted] = useState(false);
  const params = useSearchParams();

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return null;
  }

  const confetti = params.get('confetti');
  const showConfetti = confetti === 'true';

  if (!showConfetti) {
    return null;
  }

  return (
    <>
      {createPortal(
        <ReactConfetti
          numberOfPieces={1000}
          recycle={false}
          style={{ zIndex: 50 }}
        />,
        document.body,
      )}
    </>
  );
}
